import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  Button,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Spinner,
} from "reactstrap"
import { Link } from "react-router-dom"
import { get, post } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"
import cogoToast from 'cogo-toast';
import { connect } from "react-redux"

import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';

import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';

import Floor from './Floor'

const { ExportCSVButton } = CSVExport;


const Floors = props => {

  const [loading, setLoading] = React.useState(true);
  const [deleting, setDeleting] = React.useState(false);
  const [deleteThis, setDeleteThis] = React.useState(null);
  const [data, setData] = React.useState([]);
  const [id, setId] = React.useState(null);

  const selectOptions = {
    0: 'Inactive',
    1: 'Active',
    // 2: '-'
  };

  const toggleView = () => setId(null);
  const toggleDel = () => setDeleteThis(null);

  const fetchData = () => {
    setLoading(true);
      console.log('RESP:');
      get(url.GET_FLOORS+'/'+props.filterBlock.id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        setData(response.data);
        setLoading(false);
        }
      else {
        setData(null);
        setLoading(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });
  };


  React.useEffect(()=>{
    if(props.filterBlock) {
    fetchData();
    }
  }, [props.filterBlock]);



  const handleDelete = () => {
    let formdata = {
      id: deleteThis.id,
    };
    setDeleting(true);
    post(url.DELETE_FLOOR, formdata)
    .then((response) => {
      console.log('DEL RESP', response);
      if(response.status == 200) {
        cogoToast.success('Floor deleted');
        setDeleteThis(null);
        fetchData();
      }
      else if(response.status == 409) {
        cogoToast.error('Floor could not be deleted as it contains data');
      }
      else {
        console.log('err::', response);
        cogoToast.error('Floor could not be deleted');
      }
      setDeleting(false);
    }, (error) => {
      console.log(error);
      cogoToast.error('Floor could not be deleted');
      setDeleting(false);
    });

  };

  const columns = [{
    dataField: 'slno',
    text: '#'
  },
  {
    dataField: 'name',
    text: 'Floor Name',
    sort: true,
    filter: textFilter(),
  }, 
  // {
  //   dataField: 'building.block.property.name',
  //   text: 'Property',
  //   sort: true,
  //   filter: textFilter(),
  // }, 
  // {
  //   dataField: 'building.block.name',
  //   text: 'Block',
  //   sort: true,
  //   filter: textFilter(),
  // }, 
  {
    dataField: 'building.name',
    text: 'Building',
    sort: true,
    filter: textFilter(),
  }, 
  {
    dataField: 'rooms_count',
    text: 'No. of rooms',
    sort: true,
    filter: textFilter(),
  }, 
  {
    dataField: 'status',
    formatter: cell => selectOptions[cell],
    csvFormatter: cell => selectOptions[cell],
    filter: selectFilter({
      options: selectOptions,
      placeholder: 'All Statuses'
    }),
    text: 'Status',
  }, 
  {
    dataField: 'id',
    text: 'Actions',
    formatter: (cell, row, rowIndex)=> {
      return <div className="d-flex">
        <Button color="link" title="View details" onClick={()=>{
          setId(row.id);
        }}>
          <i className="bx bx-info-circle" style={{color: '#667CE8', fontSize: 19,}}></i>
        </Button>{' '}
          <Link className="btn" to={{pathname: "/floors/edit/"+row.id, query: row}}>
            <i className="bx bx-pencil" style={{color: '#667CE8', fontSize: 19,}}></i>
          </Link>{' '}
        <Button color="link" title="Delete" onClick={()=>{
        setDeleteThis(row);
        }}><i className="bx bx-trash" style={{color: 'rgb(231, 119, 147)', fontSize: 19,}}></i></Button>
      </div>;
    },
    csvExport: false,
  },
  ];


  const createExportAllHandler = ({ onExport }) => () => {
    onExport(data);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Floors | Digital Logbook</title>
        </MetaTags>
        <Container fluid>

          <ToolkitProvider
            keyField="id"
            data={ data }
            columns={ columns }
            exportCSV={ {
              fileName: 'floors.csv',
              exportAll: false,
            } }
          >
            {
              props => (
          <React.Fragment>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h3 className="mb-4">Floors ({data.length})</h3>
              <div className="d-flex justify-content-end align-items-center">
                <ExportCSVButton className="btn btn-secondary me-2" { ...props.csvProps } 
                  onClick={createExportAllHandler(props.csvProps) }  >Export All</ExportCSVButton>
                <ExportCSVButton className="btn btn-secondary me-2" { ...props.csvProps } 
                  >Export Visible</ExportCSVButton>
                <Link className="btn btn-primary" to={{pathname: "/floors/new", query: {id: 'new'}}}>Create New</Link>
              </div>
            </div>

            <Card>
              <CardBody>
                    <div>
                      <hr />
                      <BootstrapTable { ...props.baseProps } keyField='id' data={ data } filter={ filterFactory() } pagination={ paginationFactory() } />
                      {/* <BootstrapTable { ...props.baseProps } /> */}
                    </div>


              </CardBody>
            </Card>
          </React.Fragment>
          )
        }
        </ToolkitProvider>
        </Container>
      </div>
      { id !== null &&
        <Floor id={id} isOpen={id !== null} toggle={toggleView} />
      }
      { deleteThis !== null &&
      <Modal isOpen={deleteThis !== null} centered>
        <ModalHeader toggle={toggleDel}>Confirmation</ModalHeader>
        <ModalBody>
          Are you sure you want to delete {deleteThis.name}?
          <br />
        </ModalBody>
        <ModalFooter>
          <Button color="danger" disabled={deleting} onClick={handleDelete}>Delete</Button>{' '}
          <Button color="link" onClick={toggleDel}>Cancel</Button>
        </ModalFooter>
      </Modal>}

    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
  } = state.filters
  return { filterBlock }
}

export default connect(mapStatetoProps)(Floors)